var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarJobDesignationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_8541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51074 3.96903V2.62949C4.51074 2.09636 4.94695 1.66016 5.48008 1.66016H10.5207C11.0538 1.66016 11.49 2.09636 11.49 2.62949V3.96903",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6482 8.30078V13.4375C14.6482 13.9337 14.242 14.3399 13.7458 14.3399H2.25405C1.75777 14.3399 1.35156 13.9338 1.35156 13.4375V8.33086",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79668 9.82017C3.61423 9.6382 0.75 8.72816 0.75 7.09005V4.95425C0.75 4.45719 1.1554 4.05176 1.65249 4.05176H14.3475C14.8446 4.05176 15.25 4.45722 15.25 4.95425V7.09005C15.25 8.73842 12.3496 9.64957 9.14315 9.82351",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88672 8.92529H9.11286V9.96316C9.11286 10.534 8.64582 11.001 8.075 11.001H7.92458C7.35376 11.001 6.88672 10.534 6.88672 9.96316V8.92529Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_8541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarJobDesignationIcon);
export default __webpack_public_path__ + "static/media/sidebar-job-designation-icon.0607a8f4ccc9cc3f481cd8b2e1e35944.svg";
export { ForwardRef as ReactComponent };